import { useCallback } from 'react';

import { usePico } from '../pico';

function deriveHeaderCurrentPage(): string {
  if (typeof window === 'undefined') return 'unknown';
  const path = window.location.pathname;
  if (path === '/' || path === '/home' || path === '/home/') return 'homepage';
  return path;
}

export type HeaderCreateMenuItemClickedProps = {
  createMenuItem: string;
};

export function useHeaderTracking() {
  const pico = usePico();

  const trackHeaderCreateButtonClicked = useCallback(() => {
    if (pico === null) return false;
    pico.track('header_create_button_clicked', { header_current_page: deriveHeaderCurrentPage() });
    return true;
  }, [pico]);

  const trackHeaderCreateMenuItemClicked = useCallback(
    (props: HeaderCreateMenuItemClickedProps) => {
      if (pico === null) return false;
      pico.track('header_create_menu_item_clicked', {
        create_menu_item: props.createMenuItem,
        header_current_page: deriveHeaderCurrentPage(),
      });
      return true;
    },
    [pico],
  );

  const trackHeaderHelpButtonClicked = useCallback(() => {
    if (pico === null) return false;
    pico.track('header_help_button_clicked', { header_current_page: deriveHeaderCurrentPage() });
    return true;
  }, [pico]);

  const trackHeaderNotificationBellClicked = useCallback(() => {
    if (pico === null) return false;
    pico.track('header_notification_bell_clicked', {
      header_current_page: deriveHeaderCurrentPage(),
    });
    return true;
  }, [pico]);

  const trackHeaderSearchFocused = useCallback(() => {
    if (pico === null) return false;
    pico.track('header_search_focused', { header_current_page: deriveHeaderCurrentPage() });
    return true;
  }, [pico]);

  return {
    trackHeaderCreateButtonClicked,
    trackHeaderCreateMenuItemClicked,
    trackHeaderHelpButtonClicked,
    trackHeaderNotificationBellClicked,
    trackHeaderSearchFocused,
  };
}
